import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import Icon from '@@Components/Icon/Icon';
const CheckboxContainer = styled.div `
  user-select: none;
  cursor: pointer;
  ${props => props.height && `height: ${props.height};`}
  ${props => props.disabled ? `
    cursor: not-allowed;
    opacity: .4;
  ` : ''}
`;
const CheckboxInnerContainer = styled.label `
  position: relative;
  display: flex;
  cursor: pointer;
  input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
    overflow: visible;
    width: 100%;
    height: 100%;
  }
  span {
    background: #fff;
    width: 18px;
    min-width: 18px;
    height: 18px;
    border: 1px solid ${props => props.theme.input.borderColors.default};
    box-sizing: border-box;
    top: 1px !important;
    position: relative;
    transform: none !important;
    margin-right: 10px;
    svg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      display: none;
    }
  }
  input:checked + span svg {
    display: block;
  }
`;
const CheckboxDescription = styled.div `
  position: relative;
  width: 100%;
  font-size: 1rem;
  line-height: 18px;
  letter-spacing: 0px;
  a {
    text-decoration: underline;
  }
`;
const InputErrorLabel = styled.span `
  padding-top: 3px;
  color: ${props => props.theme.colors.error};
  animation: show-in 1200ms ease forwards;
  display: inline-block;
  font-size: 13px;
`;
export const Checkbox = React.forwardRef((props, ref) => {
    var _a, _b;
    const [checked, setChecked] = useState(false);
    const onChange = (e) => {
        if (props.onChange) {
            setChecked(e.target.checked);
            props.onChange(e.target.checked || false);
        }
        if (props.onBlur)
            props.onBlur();
    };
    useEffect(() => setChecked(props.checked), [props.checked]);
    return (React.createElement(CheckboxContainer, { disabled: props.disabled, height: props.height },
        React.createElement(CheckboxInnerContainer, null,
            React.createElement("input", { "data-cy": `checkbox ${props.name}`, type: "checkbox", checked: checked, disabled: props.disabled, onChange: (e) => onChange(e), onBlur: () => props.onBlur && props.onBlur(), name: props.name, ref: ref, className: props.disabled && 'disabled' }),
            React.createElement("span", { "data-cy": `checkbox span ${props.name}` },
                React.createElement(Icon, { icon: "tick", width: 9, height: 9 })),
            React.createElement(CheckboxDescription, null, props.label || props.children)),
        ((_a = props.error) === null || _a === void 0 ? void 0 : _a.message) && React.createElement(InputErrorLabel, null, (_b = props.error) === null || _b === void 0 ? void 0 : _b.message)));
});
